import { FabUserJourneyType } from '@/components/analytics/customerCustom/fab.types'

export function getRecurringUserIds(items: any) {
  const countMap: Record<string, number> = {}

  const userIds = items.map((e) => e['userId'])

  for (const id of userIds) {
    countMap[id] = (countMap[id] || 0) + 1
  }

  return Object.entries(countMap)
    .filter(([_, value]) => value > 1)
}

export function topChatCustomStatisticsCount(items: any, key: string, userIds?: string[]) {
  return (userIds ? items.filter((e) => userIds.includes(e.userId)) : items)
    .flatMap((e) => e[key] || [])
    .reduce((acc, entry) => {
      acc[entry] = (acc[entry] || 0) + 1
      return acc
    }, {})
}

export function topChatCustomStatisticValues(items: any, key: string) {
  if (!items) {
    return [{ text: 'Loading...', formula: '...' }]
  }

  const counts = topChatCustomStatisticsCount(items, key)
  // Convert counts to an array of entries, sort by value, and then convert back to an object
  return Object.entries(counts)
    .sort((a: any, b: any) => b[1] - a[1])
    .slice(0, 5)
}

export function getJourneyStats(items: any, currentPeriodData: any, userIds?: string[]) {
  const shownCount = Object.values(topChatCustomStatisticsCount(items, 'offersShown', userIds))
    .reduce((previousValue: number, currentValue: number) => previousValue + currentValue, 0) as number

  const clickedOffers = topChatCustomStatisticsCount(items, 'offerClicked', userIds)
  const clickedCount = Object.values(clickedOffers)
    .reduce((previousValue: number, currentValue: number) => previousValue + currentValue, 0) as number

  const uniqueOffers = new Set(Object.keys(clickedOffers)).size

  const interactions = Object.entries(currentPeriodData.interactionsPerUser ?? {}).reduce((acc, item) => {
    if (userIds) {
      return acc + (userIds.includes(item[0]) ? (item[1] as number || 0) : 0)
    }
    return acc + (item[1] as number || 0)
  }, 0)

  return [shownCount, clickedCount, uniqueOffers, interactions]
}

export function userJourneyStatistics(items: any, currentPeriodData: any): FabUserJourneyType {
  if (!items) {
    return { unique: {}, recurring: {} }
  }

  const [shownCount, clickedCount, uniqueOffers, interactions] = getJourneyStats(items, currentPeriodData)

  const recurringUsersAndSessions = getRecurringUserIds(items)
  const recurringSessions = recurringUsersAndSessions.map(([_, value]) => value).reduce((a, b) => a + b, 0)
  const recurringUserIds = recurringUsersAndSessions.map(([key, _]) => key)

  const [recurringShownCount, recurringClickedCount, recurringUniqueOffers, recurringInteractions] = getJourneyStats(items, currentPeriodData, recurringUserIds)

  return {
    unique: {
      users: currentPeriodData.uniqueUsers.size,
      interactions: interactions,
      sessions: currentPeriodData.chats,
      offersShown: shownCount,
      offersClicked: clickedCount,
      uniqueOffers: uniqueOffers
    },
    recurring: {
      users: recurringUserIds.length,
      interactions: recurringInteractions,
      sessions: recurringSessions,
      offersShown: recurringShownCount,
      offersClicked: recurringClickedCount,
      uniqueOffers: recurringUniqueOffers
    }
  }
}